var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block-title"},[_c('span',[_vm._v(_vm._s(_vm.labelcontainer.lable))]),_c('span',[_vm._v(_vm._s(_vm.labelcontainer.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }